import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../services';

/**
 * This component procesing transition from user mailbox by
 * clicking to email confirmation link.
 * It sent token and user id, obtained from url, to server, get response and view in snack bar result.
 */
@Component({
  selector: 'app-confirm-email',
  template: '',
})
export class ConfirmEmailComponent implements OnInit {
  constructor(private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar
  ) { }

  /**
   * Getting user id and secure token from url and
   * try to activate accaunt of user, if token expared or is not
   * valid showing error message in snack bar,
   * if success redirect to root page
   */
  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    const token =  this.route.snapshot.queryParamMap.get('token');
    this.authService.activateAccount(id, token).subscribe(result => {
      this.snackBar.open('Your account was activated.', null, {
        duration: 5000,
        panelClass: ['app-mat-snack-bar']
      });
        this.router.navigate(['']);
    });
  }
}
